import { createSelector } from 'reselect';
export const accountVerificationSelector = state => state.accountVerification;
export const verifyStateSelector = createSelector(accountVerificationSelector, ({
  verifyState
}) => verifyState);